module.exports = __webpack_public_path__ + "img/3.9d2dd0f9.jpg";